export const CONTAINER_TYPES = {
  BANNER: 'BANNER',
  MODAL: 'MODAL',
  PANEL: 'PANEL',
  SLIDE_IN: 'SLIDE_IN',
  EMBEDDED: 'EMBEDDED'
};
export const PUBLIC_CONTAINER_TYPES = [CONTAINER_TYPES.BANNER, CONTAINER_TYPES.MODAL, CONTAINER_TYPES.SLIDE_IN, CONTAINER_TYPES.EMBEDDED];
export const CONTAINER_TYPE_GATES = {};
export const CONTAINER_POSITIONS = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER',
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};
export const BANNER_POSITION_OPTIONS = [CONTAINER_POSITIONS.TOP, CONTAINER_POSITIONS.BOTTOM];
export const SLIDE_IN_POSITION_OPTIONS = [CONTAINER_POSITIONS.BOTTOM_RIGHT, CONTAINER_POSITIONS.BOTTOM_LEFT, CONTAINER_POSITIONS.TOP_LEFT, CONTAINER_POSITIONS.TOP_RIGHT];
export const DEFAULT_SECTION_ID = 'dnd_area';
export const CONTAINER_TYPES_WITH_TARGETING = [CONTAINER_TYPES.BANNER, CONTAINER_TYPES.MODAL, CONTAINER_TYPES.SLIDE_IN];
export const CONTAINER_TYPES_WITH_PREVIEW_ON_PAGE = [CONTAINER_TYPES.BANNER, CONTAINER_TYPES.MODAL, CONTAINER_TYPES.SLIDE_IN];